/** The required browser features. */
const requiredBrowserFeatures = [
    'history',
    'json',
    'localstorage',
    'postmessage',
    'urlsearchparams',
    'websockets',
];
/** Test required browser features and returns which are passed and/or failed. */
export function testBrowserFeatures() {
    return requiredBrowserFeatures.reduce(({ failed, passed }, feature) => window.Modernizr[feature]
        ? { failed, passed: [...passed, feature] }
        : { failed: [...failed, feature], passed }, { failed: [], passed: [] });
}
